import Image from 'next/image';
import type { ReactNode } from 'react';

const LOGO_SRC = '/images/wonder_lg.svg';

interface CompactPageHeroProps {
  children: ReactNode;
}

export default function CompactPageHero({ children }: CompactPageHeroProps) {
  return (
    <section className="relative z-[2] -mt-[calc(var(--site-header-height)+2px)] overflow-visible bg-[#1C1917] pb-[calc(2rem+60px)] pt-[calc(var(--site-header-height)+0.5rem)] text-white sm:pb-[calc(3rem+60px)] sm:pt-[calc(var(--site-header-height)+1.25rem)] md:pb-[calc(3.5rem+60px)] md:pt-[calc(var(--site-header-height)+1.5rem)] lg:mt-0 lg:pb-[4rem]">
      <div className="absolute inset-x-0 top-0 h-0.5 bg-[#E31E24]" />
      <div
        className="pointer-events-none absolute inset-0 overflow-hidden opacity-[0.035]"
        style={{
          backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      <div className="min-h-[6.5rem] sm:min-h-[9rem] md:min-h-[9.5rem]" aria-hidden="true" />

      <div className="absolute inset-x-0 top-[calc(var(--site-header-height)+2rem)] bottom-[calc(2rem+60px)] z-[1] flex items-center sm:top-[calc(var(--site-header-height)+4rem)] sm:bottom-[calc(3rem+60px)] md:top-[calc(var(--site-header-height)+6rem)] md:bottom-[calc(3.5rem+60px)] lg:bottom-[calc(4rem+60px)]">
        <div className="mx-auto w-full container max-sm:px-4">
          <div className="relative w-full pr-[clamp(76px,22vw,108px)] sm:pr-[clamp(108px,24vw,168px)] md:pr-[clamp(136px,22vw,210px)] lg:pr-[clamp(168px,20vw,270px)]">
            {children}
          </div>
        </div>
      </div>

      <div
        className="pointer-events-none absolute inset-x-0 bottom-12 z-[2] mx-auto container max-sm:bottom-4 max-sm:px-4"
        aria-hidden
      >
        <div className="flex justify-end">
          <Image
            src={LOGO_SRC}
            alt=""
            width={413}
            height={293}
            className="h-auto w-[clamp(76px,20vw,108px)] translate-y-[16%] object-contain object-right-bottom opacity-[0.06] sm:w-[clamp(108px,18vw,168px)] sm:translate-y-1/4 sm:opacity-[0.07] md:w-[clamp(136px,16vw,210px)] md:translate-y-[28%] lg:w-[clamp(168px,14vw,270px)] lg:translate-y-1/3"
          />
        </div>
      </div>
    </section>
  );
}
